
export default {
  data() {
    return {
      title:
        "Electric Bicycle Shipping| Electric Bike Shipping | E-Bike Shipper | BIKEFLIGHTS.COM",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
};
